import { LOGIN_STORAGE_USER, TOKEN_STORAGE_USER_KEY } from 'auth/domain/User'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

interface UserLogin {
  client: string
  first_name: string
  last_name: string
  email: string
  issuer: string
}

// The values for token and user are only retrieved once when this hook mounts
// We should probably update this when the token or user are updated
// But that's a big refactor on how we store the token and user
export function useSession() {
  const storage = new LocalStorageClient()

  const token = storage.get<string>(TOKEN_STORAGE_USER_KEY)
  let user = storage.get<UserLogin | string>(LOGIN_STORAGE_USER)

  if (!token || !user) {
    return null
  }

  // Handle case where user is stored as a JSON string (from backend responses)
  if (typeof user === 'string') {
    try {
      user = JSON.parse(user) as UserLogin
    } catch {
      // If parsing fails, return null
      return null
    }
  }

  return { token, user }
}
